export const minutesToTimeString = function(min){
    var date = new Date();
    date.setMinutes(parseInt(min));
    // set back
    var h = Math.floor(min/60);
    if(h<10)h='0'+h;
    var m = min%60;
    if(m<10)m='0'+m;
    return h+':'+m
}

export const timeStringToMinutes = function (time){
    var parts = time.split(':');
    console.log('parts', parts)
    console.log('1', parseInt(parts[1]));
    console.log('2a', parseInt(parts[1]));
    console.log('2b', parseInt(parts[0])*60);
    return parseInt(parts[1]) + (parseInt(parts[0])*60)
}